import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import logo from '@/assets/logo.svg'

export default function SiteFooter() {
  return (
    <footer className='relative bg-muted border-t border-border py-12 pb-6 overflow-hidden'>
      {/* Decorative overlay */}
      <div className='pointer-events-none absolute -top-24 right-[-10%] h-72 w-72 rounded-full bg-[hsl(var(--primary-blue))/0.2] blur-3xl' />
      <div className='container mx-auto px-4 relative'>
        <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8'>
          <div className='space-y-4'>
            <div className='flex items-center space-x-2'>
              <Image
                src={logo}
                alt='Logo'
                width={190}
                height={75}
                className='rounded-md w-[160px] h-auto md:w-[170px] md:h-auto xl:w-[190px] xl:h-auto'
              />
            </div>
            <p className='text-muted-foreground'>
              Analytics made simple. Insights made powerful. Teaching made
              impactful.
            </p>
          </div>

          <div className='space-y-4'>
            <h4 className='font-semibold text-foreground'>Product</h4>
            <div className='space-y-2 text-sm'>
              <a
                href='#features'
                className='block text-muted-foreground hover:text-foreground transition-colors'
              >
                Features
              </a>
              <a
                href='#pricing'
                className='block text-muted-foreground hover:text-foreground transition-colors'
              >
                Pricing
              </a>
            </div>
          </div>

          <div className='space-y-4'>
            <h4 className='font-semibold text-foreground'>Support</h4>
            <div className='space-y-2 text-sm'>
              <a
                href='#support'
                className='block text-muted-foreground hover:text-foreground transition-colors'
              >
                Help Center
              </a>
              <a
                href='#support-form'
                className='block text-muted-foreground hover:text-foreground transition-colors'
              >
                Contact
              </a>
            </div>
          </div>

          <div className='space-y-4'>
            <h4 className='font-semibold text-foreground'>Company</h4>
            <div className='space-y-2 text-sm'>
              <a
                href='#about'
                className='block text-muted-foreground hover:text-foreground transition-colors'
              >
                About
              </a>
              <Link
                href='/terms'
                className='block text-muted-foreground hover:text-foreground transition-colors'
              >
                Terms
              </Link>
              <a
                href='/#security-privacy'
                className='block text-muted-foreground hover:text-foreground transition-colors'
              >
                Privacy
              </a>
            </div>
          </div>
        </div>
        <div className='border-t border-foreground/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center'>
          <p className='text-sm text-muted-foreground'>
            © {new Date().getFullYear()} EduBridgeInsight. All rights reserved.
          </p>
          <div className='flex items-center space-x-4 mt-4 md:mt-0'>
            <Link
              href='/terms'
              className='text-muted-foreground hover:text-foreground transition-colors'
            >
              Terms
            </Link>
            <a
              href='/#security-privacy'
              className='text-muted-foreground hover:text-foreground transition-colors'
            >
              Privacy
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
